import { render, staticRenderFns } from "./OrganizerDetails.vue?vue&type=template&id=9cbf9406&"
import script from "./OrganizerDetails.vue?vue&type=script&lang=js&"
export * from "./OrganizerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports